import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of diet orders awaiting this (medical) provider's action:
 *  pending requests + verbal orders to co-sign + therapeutic diets due for renewal. */
export function useDietOrders(enabled = true, intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!enabled) { setCount(0); return; }
        let active = true;
        const fetchCount = () =>
            api.get("/provider/diet-orders/count").then((r) => { if (active) setCount(r.data?.count || 0); }).catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        window.addEventListener("dietorders:updated", fetchCount);
        return () => { active = false; clearInterval(id); window.removeEventListener("dietorders:updated", fetchCount); };
    }, [enabled, intervalMs]);
    return count;
}
